import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToSection = (id: string) => {
    setIsMenuOpen(false);
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${isScrolled ? 'bg-gray-900/95 backdrop-blur-sm py-4' : 'bg-transparent py-6'}`} data-id="element-112">
      <div className="container mx-auto px-4 flex justify-between items-center" data-id="element-113">
        <div className="flex items-center" data-id="element-114">
          <h1 className="text-2xl font-bold text-indigo-400" data-id="element-115">Sparrymation</h1>
        </div>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-116">
          {['portfolio', 'about', 'resume', 'contact'].map(item => <button key={item} onClick={() => scrollToSection(item)} className="text-gray-300 hover:text-indigo-400 transition-colors capitalize" data-id="element-117">
              {item}
            </button>)}
        </nav>
        {/* Mobile Navigation Button */}
        <button className="md:hidden text-gray-300 hover:text-indigo-400" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label={isMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-118">
          {isMenuOpen ? <XIcon size={24} data-id="element-119" /> : <MenuIcon size={24} data-id="element-120" />}
        </button>
      </div>
      {/* Mobile Navigation Menu */}
      {isMenuOpen && <div className="md:hidden absolute top-full left-0 w-full bg-gray-900/95 backdrop-blur-sm" data-id="element-121">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-4" data-id="element-122">
            {['portfolio', 'about', 'resume', 'contact'].map(item => <button key={item} onClick={() => scrollToSection(item)} className="text-gray-300 hover:text-indigo-400 transition-colors py-2 capitalize text-left" data-id="element-123">
                {item}
              </button>)}
          </div>
        </div>}
    </header>;
};